<template>
  <div style="padding-bottom: 0.625rem">
    <el-row>
      <el-col class="tui-col">
        <div class="tui-headerCard">
          <div class="tui-column">
            <div class="flex-items">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230153159_5204.png"
                alt=""
              />
              <div class="title">学习时长</div>
            </div>
            <div
              class="flex"
              style="align-items: baseline; justify-content: center"
            >
              <div class="time">{{ dataInfo.Time }}</div>
              <div class="hour">分钟</div>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="tui-column" @click="onClickSuccessCourse">
            <div class="flex-items">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230153213_9013.png"
                alt=""
              />
              <div class="title">
                完成课程 <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div
              class="flex"
              style="align-items: baseline; justify-content: center"
            >
              <div class="time">{{ dataInfo.CurriculumCount }}</div>
              <div class="hour">个</div>
            </div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="tui-column" @click="onClickCertificate">
            <div class="flex-items">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230153227_8617.png"
                alt=""
              />
              <div class="title">
                获得证书 <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div
              class="flex"
              style="align-items: baseline; justify-content: center"
            >
              <div class="time">{{ dataInfo.OverCount }}</div>
              <div class="hour">个</div>
            </div>
          </div>
        </div>
        <div class="tui-rightCard m-r">
          <img
            src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230152739_1973.png"
            alt=""
          />
          <div class="tui-rightColumn" @click="onClickStudent">
            <div class="title">学习记录</div>
            <div class="goOpen">点击进入</div>
          </div>
        </div>
        <div class="tui-rightCard">
          <img
            src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230152827_5596.png"
            alt=""
          />
          <div class="tui-rightColumn" @click="onClickNote">
            <div class="title">学习笔记</div>
            <div class="goOpen">点击进入</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="tui-course">培训课程</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        :label="item.Name"
        :name="item.Id + ''"
        v-for="(item, index) in tabList"
        :key="index"
      ></el-tab-pane>
    </el-tabs>
    <el-row :gutter="20" style="margin-top: 10px">
      <el-col
        :span="8"
        v-for="(item, index) in tableData"
        :key="index"
        style="margin-bottom: 0.25rem"
      >
        <div class="grid-content bg-purple" @click="onCLickCourseDetail(item)">
          <div class="tui-img">
            <el-image
              style="width: 1.6625rem; height: 1.3875rem"
              :src="item.Image"
              fit="cover"
            ></el-image>
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230160103_4046.png"
              class="tui-pause"
              alt=""
            />
          </div>
          <div class="coulmn">
            <div class="title">{{ item.Name }}</div>
            <div class="flex-items">
              <div class="tui-progress">学习进度</div>
              <el-progress
                style="width: 100%"
                define-back-color="rgba(0,167,255,0.1)"
                color="#35C3FF"
                :percentage="item.Progress"
              ></el-progress>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;padding:20px; 0 0 0"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  GetTeacherStudyInfo,
  GetCateInfo,
  GetSecVideoInfo,
} from "../../api/api";

export default {
  data() {
    return {
      activeName: 0,
      dataInfo: {},
      tabList: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      tableData: [],
      userInfo: {},
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetTeacherStudyInfo();
    await this.GetCateInfo();
    await this.GetSecVideoInfo();
  },
  methods: {
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetSecVideoInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetSecVideoInfo();
    },
    async GetSecVideoInfo() {
      let res = await GetSecVideoInfo({
        Pid: this.activeName,
        TeacherId: this.userInfo.TeacherId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetTeacherStudyInfo() {
      let res = await GetTeacherStudyInfo({
        Id: this.userInfo.TeacherId,
      });
      if (res.data.success) {
        this.dataInfo = res.data.response;
      }
    },
    async GetCateInfo() {
      let res = await GetCateInfo();
      if (res.data.success) {
        this.tabList = res.data.response;
        this.activeName = res.data.response[0].Id + "";
      }
    },
    // 课程详情
    onCLickCourseDetail(item) {
      this.$router.push({
        path: "/Teacher-Tain/detail",
        query: {
          Pid: item.Id,
        },
      });
    },
    // 完成课程
    onClickSuccessCourse() {
      this.$router.push({
        path: "/Teacher-Tain/success-note",
      });
    },
    // 我的证书
    onClickCertificate() {
      this.$router.push({
        path: "/Teacher-Tain/certificate",
      });
    },
    handleClick(e) {
      this.activeName = e.name;
      this.GetSecVideoInfo();
    },
    // 学习记录
    onClickStudent() {
      this.$router.push({
        path: "/Teacher-Tain/record",
      });
    },
    // 学习笔记
    onClickNote() {
      this.$router.push({
        path: "/Teacher-Tain/note",
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-divider--vertical {
  height: 0.725rem;
  background: rgba(255, 255, 255, 0.3);
}
/deep/.el-progress__text {
  margin-left: 0.1875rem;
  font-size: 0.225rem;
  color: #999;
}
.grid-content {
  height: 2rem;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  padding: 0.3125rem;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  .coulmn {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 0.1875rem;
    .tui-progress {
      flex-shrink: 0;
      color: #999999;
      font-size: 0.225rem;
      padding-right: 0.125rem;
    }
    .title {
      color: #333333;
      font-size: 0.25rem;
      font-weight: 600;
      padding-bottom: 0.25rem;
    }
  }
  .tui-img {
    width: 1.6625rem;
    height: 1.3875rem;
    background: red;
    position: relative;
    border-radius: 0.25rem;
    .tui-pause {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
.tui-course {
  color: #333;
  font-size: 0.3rem;
  font-weight: 600;
  padding: 0.375rem 0;
}
.tui-col {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .tui-headerCard {
    flex: 1;
    height: 1.75rem;
    background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-30/20221230151111_4331.png")
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .tui-column {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      .title {
        color: #fff;
        font-size: 0.25rem;
        padding-left: 0.125rem;
      }
      .time {
        color: #fff;
        font-size: 0.475rem;
      }
      .hour {
        color: #fff;
        font-size: 0.1875rem;
        padding-left: 0.0625rem;
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
  }
  .tui-rightCard {
    width: 2.8125rem;
    height: 1.75rem;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .tui-rightColumn {
      display: flex;
      flex-direction: column;
      padding-left: 0.125rem;
      cursor: pointer;
      .title {
        color: #333;
        font-size: 0.3rem;
        font-weight: 600;
      }
      .goOpen {
        color: #999999;
        font-size: 0.2rem;
        padding-top: 0.1rem;
      }
    }
  }
  .m-r {
    margin: 0 0.25rem;
  }
}
</style>